<div id="settings-trigger" (click)="toggleThemeSettings()"><i class="mdi mdi-cog"></i></div>
<div id="theme-settings" class="settings-panel">
  <i class="settings-close mdi mdi-close" (click)="closeSettingsSidebar('theme')"></i>
  <p class="settings-heading mt-2">HEADER SKINS</p>
  <div class="color-tiles mx-0 px-4">
    <div class="tiles primary" (click)="changeNavbarTheme('primary')"></div>
    <div class="tiles success" (click)="changeNavbarTheme('success')"></div>
    <div class="tiles warning" (click)="changeNavbarTheme('warning')"></div>
    <div class="tiles danger" (click)="changeNavbarTheme('danger')"></div>
    <div class="tiles info" (click)="changeNavbarTheme('info')"></div>
    <div class="tiles light" (click)="changeNavbarTheme('default')"></div>
    <div class="tiles default dark" (click)="changeNavbarTheme('dark')"></div>
  </div>
  <p class="settings-heading mt-2">LAYOUT OPTIONS</p>
  <div class="layout-variations px-4 mx-2 mt-3">
    <div class="form-check layout-item">
      <label class="form-check-label">
        <input type="radio" class="form-check-input" name="layout-variations" [checked]="isDefaultLayout"
          (change)="changeLayout('default')">
        Default
        <i class="input-helper"></i>
      </label>
    </div>
    <div class="form-check layout-item">
      <label class="form-check-label">
        <input type="radio" class="form-check-input" name="layout-variations" [checked]="isBoxedLayout"
          (change)="changeLayout('boxed')">
        Boxed Layout
        <i class="input-helper"></i>
      </label>
    </div>
    <div class="form-check layout-item">
      <label class="form-check-label">
        <input type="radio" class="form-check-input" name="layout-variations" [checked]="isSidebarIconOnly"
          (change)="changeLayout('icon-menu')">
        Icon Menu
        <i class="input-helper"></i>
      </label>
    </div>
    <div class="form-check layout-item">
      <label class="form-check-label">
        <input type="radio" class="form-check-input" name="layout-variations" [checked]="isCompactMenu"
          (change)="changeLayout('compact-menu')">
        Compact Menu
        <i class="input-helper"></i>
      </label>
    </div>
    <div class="form-check layout-item">
      <label class="form-check-label">
        <input type="radio" class="form-check-input" name="layout-variations" [checked]="isFixedSidebar"
          (change)="changeLayout('fixed-sidebar')">
        Fixed Sidebar
        <i class="input-helper"></i>
      </label>
    </div>
    <div class="form-check layout-item">
      <label class="form-check-label">
        <input type="radio" class="form-check-input" name="layout-variations" [checked]="isHiddenSidebar"
          (change)="changeLayout('hidden-sidebar')">
        Hidden Sidebar
        <i class="input-helper"></i>
      </label>
    </div>
    <div class="form-check layout-item">
      <label class="form-check-label">
        <input type="radio" class="form-check-input" name="layout-variations" [checked]="isOverlaySidebar"
          (change)="changeLayout('overlay-sidebar')">
        Overlay Sidebar
        <i class="input-helper"></i>
      </label>
    </div>
  </div>
</div>
<div id="right-sidebar" class="settings-panel">
  <i class="settings-close mdi mdi-close" (click)="closeSettingsSidebar('main')"></i>
  <div class="border-top right-sidebar-tab">
    <ngb-tabset>
      <ngb-tab title="EVENTS">
        <ng-template ngbTabContent>
          <div class="tab-pane fade show active scroll-wrapper" id="todo-section" role="tabpanel"
            aria-labelledby="todo-section">
            <div class="px-3">

            </div>
            <h4 class="px-3 text-muted mt-5 font-weight-light mb-0">Events</h4>
            <div class="events pt-4 px-3">
              <div class="wrapper d-flex mb-2">
                <i class="mdi mdi-checkbox-blank-circle-outline text-primary mr-2"></i>
                <span>Feb 11 2018</span>
              </div>
              <p class="mb-0 font-weight-thin text-gray">Creating component page build a js</p>
              <p class="text-gray mb-0">The total number of sessions</p>
            </div>
            <div class="events pt-4 px-3">
              <div class="wrapper d-flex mb-2">
                <i class="mdi mdi-checkbox-blank-circle-outline text-primary mr-2"></i>
                <span>Feb 7 2018</span>
              </div>
              <p class="mb-0 font-weight-thin text-gray">Meeting with Alisa</p>
              <p class="text-gray mb-0 ">Call Sarah Graves</p>
            </div>
          </div>
        </ng-template>
      </ngb-tab>

      <ngb-tab title="CHATS">
        <ng-template ngbTabContent>
          <div class="tab-pane" id="chats-section" role="tabpanel" aria-labelledby="chats-section">
            <div class="d-flex align-items-center justify-content-between border-bottom">
              <p class="settings-heading border-top-0 mb-3 pl-3 pt-0 border-bottom-0 pb-0">Friends</p>
              <small class="settings-heading border-top-0 mb-3 pt-0 border-bottom-0 pb-0 pr-3 font-weight-normal">See
                All</small>
            </div>
            <ul class="chat-list">
              <li class="list active">
                <div class="profile"><img src="https://via.placeholder.com/86x86" alt="image"><span
                    class="online"></span></div>
                <div class="info">
                  <p>Thomas Douglas</p>
                  <p>Available</p>
                </div>
                <small class="text-muted my-auto">19 min</small>
              </li>
              <li class="list">
                <div class="profile"><img src="https://via.placeholder.com/86x86" alt="image"><span
                    class="offline"></span></div>
                <div class="info">
                  <div class="wrapper d-flex">
                    <p>Catherine</p>
                  </div>
                  <p>Away</p>
                </div>
                <div class="badge badge-success badge-pill my-auto mx-2">4</div>
                <small class="text-muted my-auto">23 min</small>
              </li>
              <li class="list">
                <div class="profile"><img src="https://via.placeholder.com/86x86" alt="image"><span
                    class="online"></span></div>
                <div class="info">
                  <p>Daniel Russell</p>
                  <p>Available</p>
                </div>
                <small class="text-muted my-auto">14 min</small>
              </li>
              <li class="list">
                <div class="profile"><img src="https://via.placeholder.com/86x86" alt="image"><span
                    class="offline"></span></div>
                <div class="info">
                  <p>James Richardson</p>
                  <p>Away</p>
                </div>
                <small class="text-muted my-auto">2 min</small>
              </li>
              <li class="list">
                <div class="profile"><img src="https://via.placeholder.com/86x86" alt="image"><span
                    class="online"></span></div>
                <div class="info">
                  <p>Madeline Kennedy</p>
                  <p>Available</p>
                </div>
                <small class="text-muted my-auto">5 min</small>
              </li>
              <li class="list">
                <div class="profile"><img src="https://via.placeholder.com/86x86" alt="image"><span
                    class="online"></span></div>
                <div class="info">
                  <p>Sarah Graves</p>
                  <p>Available</p>
                </div>
                <small class="text-muted my-auto">47 min</small>
              </li>
            </ul>
          </div>
        </ng-template>
      </ngb-tab>

    </ngb-tabset>
  </div>
</div>
